export default '/build/95455395.svg'